<script setup>
definePage({ meta: { action: 'read', subject: 'surveys' } })

import SubjectList from '@/views/sms/SubjectList.vue'
import TemplateList from '@/views/sms/TemplateList.vue'
import MessageForm from '@/views/sms/MessageForm.vue'
import ResultList from '@/views/sms/ResultList.vue'

const currentTab = ref(0)
const selectedTemplate = ref(null)
const selectedSubjects = ref([])

const resultListRef = ref(null)
const templateListRef = ref(null)

watch(currentTab, (tab) => {
  if (tab === 1) {
    resultListRef.value?.reload()
  }
})
</script>

<template>
  <VRow>
    <VCol cols="12">
      <VTabs
        v-model="currentTab"
        class="v-tabs-pill"
      >
        <VTab>메시지 전송</VTab>
        <VTab>전송 결과</VTab>
      </VTabs>

      <VWindow
        v-model="currentTab"
        class="disable-tab-transition"
      >
        <VWindowItem :value="0">
          <VRow class="mt-4">
            <VCol cols="12" md="4">
              <SubjectList @update:subjects="val => selectedSubjects = val" />
            </VCol>
            <VCol cols="12" md="4">
              <TemplateList ref="templateListRef" @apply-template="tmpl => selectedTemplate = { ...tmpl }" />
            </VCol>
            <VCol cols="12" md="4">
              <MessageForm :template="selectedTemplate" :subjects="selectedSubjects" />
            </VCol>
          </VRow>
        </VWindowItem>

        <VWindowItem :value="1">
          <div class="mt-4">
            <ResultList ref="resultListRef" />
          </div>
        </VWindowItem>
      </VWindow>
    </VCol>
  </VRow>
</template>

<style lang="scss">
/* 탭 스타일 */
.v-tabs.v-tabs-pill {
  .v-slide-group-item--active.v-tab--selected {
    background-color: #6A78D3;
    color: white;
    font-weight: bold;
  }
}

.v-tabs.v-tabs-pill .v-tab.v-btn{
  border : 1px solid #6A78D3;
  color: #2F45B8;
  margin-inline-end: 10px;
}

.template-sort-select {
  max-width: 110px;
  font-size: 0.75rem;

  .v-field {
    --v-field-padding-top: 2px;
    --v-field-padding-bottom: 2px;
    min-height: auto;
  }

  .v-field__input {
    padding-block: 2px;
    min-height: auto;
    font-size: 0.75rem;
  }
}

.v-tabs.v-tabs-pill--sm {
  --v-tabs-height: 30px;

  .v-tab.v-btn {
    min-width: auto;
    padding: 0 12px;
    font-size: 0.75rem;
    height: 28px;
  }
}
</style>
